const SqlParserUtil = require('./SqlParserUtil');

const ResourceDispatchUtil = {};

/** 
 * @param opts
 * @param opts.destination
 * @param opts.tableInfo
 * @param opts.requiredList
 */
ResourceDispatchUtil.makeRescueAggregates = function(opts) {
    let aggregateList = [];
    let geometry = {
        type: 'Point',
        coordinates: opts.destination
    }
    let tableName = opts.tableInfo.table;
    let typeField = opts.tableInfo.typeField;
    for (let i = 0; i < opts.requiredList.length; i++) {
        let requireItem = opts.requiredList[i];
        let aggregateObj = {},
            aggregate = [];
        aggregateObj.query = {};
        aggregateObj.searchId = i;
        aggregateObj.dataSetId = tableName;
        aggregateObj.queryIndex = 1;
        aggregateObj.aggregate = aggregate;
        //filter
        let queryAnd = [];
        if (requireItem.filter) {
            let parseWhereResult = SqlParserUtil.parseSqlFragment('where', requireItem.filter);
            let query = SqlParserUtil.translateWhere(parseWhereResult);
            queryAnd.push(query);
        }
        let typeQuery = {};
        typeQuery['tag.' + typeField] = requireItem.type;
        queryAnd.push(typeQuery);
        //geonear
        let geoNear = {};
        geoNear.limit = 1000 * 1000;
        geoNear.maxDistance = requireItem.maxDistance || 5000 * 1000;
        geoNear.minDistance = requireItem.minDistance || 0;
        geoNear.spherical = true;
        geoNear.near = geometry;
        geoNear.includeLocs = "geom";
        geoNear.distanceField = "distance";
        if (queryAnd.length > 0) {
            geoNear.query = {
                $and: queryAnd
            };
        }
        aggregate.push({
            $geoNear: geoNear
        });
        aggregate.push({
            $project: {
                'tag': '$tag',
                'id': '$_id',
                'geometry': '$geom',
                '_d': '$distance'
            }
        });
        aggregateList.push(aggregateObj);
    }
    return aggregateList;
}

//提取所有满足情况
ResourceDispatchUtil.extractRescueFulfillCol = function(opts, resultCol) {
    let fulfillCol = [];
    for (let i = 0; i < opts.requiredList.length; i++) {
        let requireObj = opts.requiredList[i];
        let fulfilResult = this.extractRescueFulfill(requireObj, resultCol[i][opts.tableInfo.table], opts.tableInfo);
        fulfillCol.push({
            type: requireObj.type,
            list: fulfilResult.list,
            num: fulfilResult.num
        });
    }
    return fulfillCol;
}

//提取单类满足情况
ResourceDispatchUtil.extractRescueFulfill = function(requiredObj, list, tableInfo) {
    let fulfilResult = {};
    let fulfilList = [];
    requiredObj.numType = requiredObj.numType || 1;
    let groupCol = this.makeRescuePriorityGroup(requiredObj.priority, list);
    //
    let fulfilVal = 0,
        fulfilFlag = false,
        numField = tableInfo.numField;
    if (requiredObj.numType == 1) { //队伍数
        for (let i = 0; i < groupCol.length; i++) {
            let groupList = groupCol[i];
            if (groupList.length > requiredObj.num) {
                fulfilList = groupList.slice(0, requiredObj.num);
                fulfilVal += requiredObj.num;
            } else {
                fulfilList = fulfilList.concat(groupList);
                fulfilVal += groupList.length;
            }
        }
    } else if (requiredObj.numType == 2) { //按照人数
        for (let i = 0; i < groupCol.length; i++) {
            let groupList = groupCol[i];
            for (let j = 0; j < groupList.length; j++) {
                let item = groupList[j];
                if (fulfilVal >= requiredObj.num) {
                    break;
                }
                let itemNum = parseFloat(item[numField]);
                let dispatchNum = itemNum;
                if (fulfilVal + itemNum > requiredObj.num) {
                    dispatchNum = requiredObj.num - fulfilVal;
                }
                fulfilVal += dispatchNum;
                item.dispatch_num = dispatchNum;
                fulfilList.push(item);
            }
            if (fulfilVal >= requiredObj.num) {
                break;
            }
        }
    }
    fulfilResult.num = fulfilVal;
    fulfilResult.list = fulfilList;
    return fulfilResult;
}

//优先级
ResourceDispatchUtil.makeRescuePriorityGroup = function(priority, list) {
    let groupCol = [];
    if (priority) {
        for (let i = 0; i < priority.values.length; i++) {
            let value = priority.values[i];
            let groupList = [];
            for (let j = list.length - 1; j >= 0; j--) {
                let item = list[j];
                if (item.tag && item.tag[priority.field] == value) {
                    let tempObj = {
                        id: item.id,
                        geometry: item.geometry,
                        distance: item._d
                    }

                    //todo 
                    tempObj.geom = item.geometry;
                    for (let kk in item.tag) {
                        tempObj[kk] = item.tag[kk];
                    }
                    groupList.push(tempObj);
                    //
                    list.splice(j, 1);
                }
            }
            groupCol.push(groupList);
        }
    } else {
        groupCol.push(list);
    }
    return groupCol;
}

/**
 * 路径规划
 * @param opts
 * @param opts.service
 * @param opts.destination
 * @param opts.spatialReference
 * @param opts.dispatchCol
 * @param opts.routeParams
 */
ResourceDispatchUtil.planRoutes = function(opts) {
    return new Promise(async(resolve, reject) => {
        opts.routeParams = opts.routeParams || {};
        for (let m = 0; m < opts.dispatchCol.length; m++) {
            let dispatchList = opts.dispatchCol[m].list;
            for (let i = 0; i < dispatchList.length; i++) {
                let item = dispatchList[i];
                let route = await ResourceDispatchUtil.planRouteEach({
                    service: opts.service,
                    startPos: [item.geometry.coordinates[0], item.geometry.coordinates[1]],
                    endPos: opts.destination,
                    routeParams: opts.routeParams,
                    spatialReference: opts.spatialReference
                });
                item.route = route;
            }
        }
        resolve();
    });
}

/**
 * 路径规划
 * @param opts
 * @param opts.service
 * @param opts.startPos
 * @param opts.endPos
 * @param opts.spatialReference
 * @param opts.routeParams
 */
ResourceDispatchUtil.planRouteEach = function(opts) {
    return new Promise(async(resolve, reject) => {
        let result = await opts.service.driving({
            origin: opts.startPos,
            destination: opts.endPos,
            spatialReference: opts.spatialReference,
            custom: opts.routeParams.custom || {}
        });
        resolve(result);
    });
}



/** 
 * @param opts
 * @param opts.destination
 * @param opts.tableInfo
 * @param opts.requiredList
 */
ResourceDispatchUtil.makeMaterialAggregates = function(opts) {
    let aggregateList = [];
    let geometry = {
        type: 'Point',
        coordinates: opts.destination
    }
    let reposityInfo = opts.tableInfo.reposity;
    let materialInfo = opts.tableInfo.material;
    let aggregateObj = {},
        aggregate = [];
    aggregateObj.query = {};
    aggregateObj.searchId = i;
    aggregateObj.dataSetId = reposityInfo.table;
    aggregateObj.queryIndex = 1;
    aggregateObj.aggregate = aggregate;
    //geonear
    let geoNear = {};
    geoNear.limit = 1000 * 1000;
    geoNear.maxDistance = opts.maxDistance || 5000 * 1000;
    geoNear.minDistance = opts.minDistance || 0;
    geoNear.spherical = true;
    geoNear.near = geometry;
    geoNear.includeLocs = "geom";
    geoNear.distanceField = "distance";
    aggregate.push({
        $geoNear: geoNear
    });
    //relation
    let lookup = {};
    lookup.from = 'user_safety_' + materialInfo.table;
    lookup.localField = '_id';
    lookup.foreignField = 'tag.' + materialInfo.reposityField;
    lookup.as = 'materials';
    aggregate.push({
        $lookup: lookup
    });
    aggregateList.push(aggregateObj);
    return aggregateList;
}

//提取所有满足情况
//todo 临时简单处理，查询物资类型都有的仓库
ResourceDispatchUtil.extractMaterialFulfillCol = function(opts, resultCol) {
    let fulfillCol = [];
    let reposityList = resultCol[0][opts.tableInfo.reposity.table];
    //
    let typeField = opts.tableInfo.material.typeField;
    for (let i = 0; i < opts.requiredList.length; i++) {
        let requiredObj = opts.requiredList[i];
        let requriedTypeSet = {};
        let typeList = requiredObj.type.split(',');
        let typeCount = typeList.length;
        for (let j = 0; j < typeList.length; j++) {
            requriedTypeSet[typeList[j]] = [];
        }
        let fulfilList = [];
        for (let i = 0, len = reposityList.length; i < len; i++) {
            let reposity = reposityList[i];
            let tempObj = {};
            //
            tempObj.id = reposity._id;
            tempObj.geometry = reposity.geom;
            //todo
            tempObj.geom = reposity.geom;
            tempObj.distance = reposity.distance;
            tempObj.materials = reposity.materials;
            for (let kk in reposity.tag) {
                tempObj[kk] = reposity.tag[kk];
            }
            let materials = reposity.materials || [];
            let matchTypeCount = 0;
            for (let j = 0, len1 = materials.length; j < len1; j++) {
                let materialObj = materials[j];
                materialObj.id = materialObj._id;
                for (let kk in materialObj.tag) {
                    materialObj[kk] = materialObj.tag[kk];
                }
                delete materialObj._id;
                delete materialObj.tag;
                let requriedTypeReposityList = requriedTypeSet[materialObj[typeField]];
                if (requriedTypeReposityList) { //分物资类型加标记
                    tempObj._index = requriedTypeReposityList.length;
                    requriedTypeReposityList.push(tempObj);
                    matchTypeCount++;
                }
            }
            if (matchTypeCount > 0) {
                fulfilList.push(tempObj);
            }
        }
        //临时
        if (opts.limit) {
            fulfilList.sort(function(a, b) {
                return a._index - b._index;
            });
            fulfilList = fulfilList.slice(0, opts.limit);
            fulfilList.sort(function(a, b) {
                return a.distance - b.distance;
            });
        }
        fulfillCol.push({
            type: requiredObj.type,
            list: fulfilList
        });
    }

    return fulfillCol;
}


module.exports = ResourceDispatchUtil;